export default __webpack_public_path__ + "static/media/btn-zeroback-stop-es_es@2x.90141d38.png";